import React, { useState } from "react";
import { ArrowDownToLine, ArrowUpFromLine } from "lucide-react";
import FeedSyncCard from "@/components/FeedSyncCard";
import { GestionaleWebhookCard } from "@/components/profile/GestionaleWebhookCard";

const TABS = [
    { id: "import", icon: ArrowDownToLine, label: "Il tuo gestionale → VendiDirect", hint: "Import annunci da feed XML/CSV" },
    { id: "export", icon: ArrowUpFromLine, label: "VendiDirect → Il tuo gestionale", hint: "Export webhook giornaliero" },
];

export default function GestionaleDrawerContent({ initialTab = "import" }) {
    const [tab, setTab] = useState(initialTab);
    return (
        <div data-testid="gestionale-drawer" className="pro-dash">
            <div role="tablist" className="mb-6 grid grid-cols-1 gap-2 sm:grid-cols-2">
                {TABS.map((t) => {
                    const active = tab === t.id;
                    return (
                        <button
                            key={t.id}
                            role="tab"
                            aria-selected={active}
                            data-testid={`gestionale-tab-${t.id}`}
                            onClick={() => setTab(t.id)}
                            className={`flex items-center gap-3 rounded-2xl border px-4 py-3 text-left transition-colors ${active ? "border-[var(--pd-accent-border)] bg-[var(--pd-accent-bg)]" : "border-[var(--pd-border)] bg-[var(--pd-surface)] hover:border-[var(--pd-accent-border)]"}`}
                        >
                            <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-xl ${active ? "bg-[var(--pd-icon)] text-[var(--pd-surface)]" : "bg-[var(--pd-icon-bg)] text-[var(--pd-icon)]"}`}><t.icon size={16} /></span>
                            <span className="min-w-0">
                                <span className="block truncate text-sm font-semibold text-[var(--pd-text)]">{t.label}</span>
                                <span className="block text-[11px] text-[var(--pd-muted)]">{t.hint}</span>
                            </span>
                        </button>
                    );
                })}
            </div>

            {tab === "import" && (
                <section data-testid="gestionale-section-import">
                    <FeedSyncCard />
                </section>
            )}
            {tab === "export" && (
                <section data-testid="gestionale-section-export">
                    <GestionaleWebhookCard eyebrow="Export giornaliero" title="VendiDirect → Il tuo gestionale" className="profile-neu-card" />
                </section>
            )}
        </div>
    );
}
